import { render, staticRenderFns } from "./Jugendgetraenke.vue?vue&type=template&id=747f51db&scoped=true"
import script from "./Jugendgetraenke.vue?vue&type=script&lang=js"
export * from "./Jugendgetraenke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f51db",
  null
  
)

export default component.exports